<script lang="ts">
	import { fly } from 'svelte/transition';
	import { cubicIn, cubicOut } from 'svelte/easing';
	import { page } from '$app/state';
	import { t, path } from '$lib/translations';
	import { descendsFrom, ƒ_about, ƒ_photographs, ƒ_thoughts, routeEq, ƒ_home } from '$lib/routes';

	import LocaleSwitch from './LocaleSwitch.svelte';
	import Logo from './Logo.svelte';

	let { route } = $derived(page);

	let currentRouteDescendsFrom = $derived(descendsFrom(route));

	let photographsIsActive = $derived(currentRouteDescendsFrom(ƒ_photographs));
	let thoughtsIsActive = $derived(currentRouteDescendsFrom(ƒ_thoughts));
	let aboutIsActive = $derived(currentRouteDescendsFrom(ƒ_about));

	const duration = 300;
	const y = 10;

	const transitionIn = (delay: number) => ({ easing: cubicOut, y, duration, delay: 400 + delay });
	const transitionOut = () => ({ easing: cubicIn, y: -y, duration });
</script>

<div class="header | grid">
	<div style:grid-area="logo">
		<Logo />
	</div>
	<div class="before">
		<div>
			<a href={$path(ƒ_photographs)}>
				{#key $t(`menu.photos`)}
					<span
						class="inline-block max-sm:text-xs"
						in:fly={transitionIn(400)}
						out:fly={transitionOut()}
						class:text-bridal-heath-50={photographsIsActive}
						class:raw-underline-white={photographsIsActive}
						class:animated-underline-white={!photographsIsActive}>{$t(`menu.photos`)}</span
					>
				{/key}
			</a>
		</div>
		<div>
			<a href={$path(ƒ_thoughts)} title="pensieri /s(c|p)arsi/, actually">
				{#key $t(`menu.sparse.thoughts`)}
					<span
						class="inline-block max-sm:text-xs"
						in:fly={transitionIn(600)}
						out:fly={transitionOut()}
						class:text-bridal-heath-50={thoughtsIsActive}
						class:raw-underline-white={thoughtsIsActive}
						class:animated-underline-white={!thoughtsIsActive}
					>
						<span class="max-sm:hidden">{$t(`menu.sparse.thoughts`)}</span>
						<span class="md:hidden">{$t(`menu.thoughts`)}</span>
					</span>
				{/key}
			</a>
		</div>
	</div>
	<div class="after">
		<div>
			<a href={$path(ƒ_about)}>
				{#key $t(`menu.about.me`)}
					<span
						class="inline-block max-sm:text-xs"
						in:fly={transitionIn(800)}
						out:fly={transitionOut()}
						class:text-bridal-heath-50={aboutIsActive}
						class:raw-underline-white={aboutIsActive}
						class:animated-underline-white={!aboutIsActive}
					>
						<span class="max-sm:hidden">{$t(`menu.about.me`)}</span>
						<span class="md:hidden">{$t(`menu.about`)}</span>
					</span>
				{/key}
			</a>
		</div>
	</div>
	<div class="right">
		<LocaleSwitch />
	</div>
</div>

<style lang="postcss">
	@reference "tailwindcss";

	.header {
		@apply gap-2 md:gap-4 m-auto px-4 pt-2;

		display: grid;

		grid-template-areas: 'left before logo after right';
		align-items: center;
		grid-template-columns: 2rem 1fr auto 1fr 2rem;

		@media (width >= theme(--breakpoint-md)) {
			grid-template-columns: 4rem 1fr auto 1fr 4rem;
		}

		.before,
		.after {
			@apply gap-2 md:gap-8;
			display: flex;
		}

		.before {
			grid-area: before;
			justify-content: right;
		}

		.after {
			grid-area: after;
		}

		.right {
			grid-area: right;
			text-align: right;
		}
	}
</style>
